import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Alert from "@mui/material/Alert";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import LinearProgress from "@mui/material/LinearProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

// Force display names in React DevTools - this fixes MUI components showing as Grid2, etc.
(Stack as any).displayName = "Stack";
(Grid as any).displayName = "Grid";
(Card as any).displayName = "Card";
(CardHeader as any).displayName = "CardHeader";
(CardContent as any).displayName = "CardContent";
(CardActions as any).displayName = "CardActions";
(Typography as any).displayName = "Typography";
(IconButton as any).displayName = "IconButton";
(Tooltip as any).displayName = "Tooltip";
(Chip as any).displayName = "Chip";
(Menu as any).displayName = "Menu";
(MenuItem as any).displayName = "MenuItem";
(MenuList as any).displayName = "MenuList";
(Box as any).displayName = "Box";
(Alert as any).displayName = "Alert";
(Snackbar as any).displayName = "Snackbar";
(Button as any).displayName = "Button";
(TextField as any).displayName = "TextField";
(Dialog as any).displayName = "Dialog";
(DialogTitle as any).displayName = "DialogTitle";
(DialogContent as any).displayName = "DialogContent";
(DialogActions as any).displayName = "DialogActions";
(FormControl as any).displayName = "FormControl";
(InputLabel as any).displayName = "InputLabel";
(Select as any).displayName = "Select";
(Checkbox as any).displayName = "Checkbox";
(FormControlLabel as any).displayName = "FormControlLabel";
(Paper as any).displayName = "Paper";
(Table as any).displayName = "Table";
(TableBody as any).displayName = "TableBody";
(TableCell as any).displayName = "TableCell";
(TableContainer as any).displayName = "TableContainer";
(TableHead as any).displayName = "TableHead";
(TableRow as any).displayName = "TableRow";
(CircularProgress as any).displayName = "CircularProgress";
(LinearProgress as any).displayName = "LinearProgress";
(Drawer as any).displayName = "Drawer";
(List as any).displayName = "List";
(ListItem as any).displayName = "ListItem";
(ListItemText as any).displayName = "ListItemText";
(ListItemIcon as any).displayName = "ListItemIcon";
(Divider as any).displayName = "Divider";
(AppBar as any).displayName = "AppBar";
(Toolbar as any).displayName = "Toolbar";
(Badge as any).displayName = "Badge";
(Avatar as any).displayName = "Avatar";
(Tab as any).displayName = "Tab";
(Tabs as any).displayName = "Tabs";
(Accordion as any).displayName = "Accordion";
(AccordionSummary as any).displayName = "AccordionSummary";
(AccordionDetails as any).displayName = "AccordionDetails";
